var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleArrowSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.519761 19.4576C-0.173254 18.7344 -0.173254 17.5619 0.519761 16.8387L7.07307 10L0.51976 3.16131C-0.173254 2.43812 -0.173254 1.26559 0.51976 0.542395C1.21277 -0.180799 2.33637 -0.180799 3.02939 0.542395L9.83366 7.64298C11.0811 8.94472 11.0811 11.0553 9.83366 12.357L3.02939 19.4576C2.33637 20.1808 1.21277 20.1808 0.519761 19.4576Z",
    fill: "#5D38E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleArrowSmall);
export default __webpack_public_path__ + "static/media/purple_arrow_small.aee197bb138d9dd7a0a4ad2d3b6bcd51.svg";
export { ForwardRef as ReactComponent };